var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('base-header'),_c('div',{attrs:{"id":"content"}},[_c('router-view')],1),_c('base-footer'),_c('screen-alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }